var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('inertia-head',{attrs:{"title":_vm.title}}),_vm._v(" "),_c('div',{staticClass:"container py-5"},[_c('h1',{staticClass:"h1"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }